import { css, cx } from "@emotion/css"

import Text from "../../ui/Text/Text"

type Props = {
  id: string | undefined
  children: string
  labelAlign?: "left" | "right"
  type?: "required" | "optional"
  asGroup?: boolean
  alignBaseLine?: boolean
}

const FieldLabel = ({ id, children, type, labelAlign, asGroup = false, alignBaseLine = true }: Props) => {
  const containerClassName = cx(
    styles.label,
    labelAlign === "left" && styles.labelAlignLeft,
    labelAlign === "right" && styles.labelAlignRight,
    alignBaseLine && styles.alignBaseLine
  )

  return (
    <span className={containerClassName}>
      <Text tag="span">{asGroup ? <span id={id}>{children}</span> : <label htmlFor={id}>{children}</label>}</Text>
      {type === "required" && <span className={cx(styles.remarks, styles.required)}>（必須）</span>}
      {type === "optional" && <span className={styles.remarks}>（任意）</span>}
    </span>
  )
}

export default FieldLabel

const styles = {
  label: css`
    display: flex;
    flex-wrap: wrap;
    white-space: pre-line;
  `,
  labelAlignLeft: css`
    padding-right: 5px;
  `,
  labelAlignRight: css`
    justify-content: flex-end;
    padding-right: 15px;
  `,
  /**
   * TextInputやSelectのベースラインに合わせるための指定です。
   */
  alignBaseLine: css`
    padding-top: 7px;
  `,
  remarks: css`
    /* 改行の制御のため指定 */
    display: inline-block;

    padding-top: 2px;
    font-size: 11px;
  `,
  required: css`
    color: #ff0000;
  `,
}
